import { Layout, Breadcrumb } from "antd";
import { Link, Outlet, useLocation } from "react-router-dom";
import { LinkButton } from "../components/LinkButton";
import { SideBar } from "./sidebar";
import { PropsWithChildren, useEffect } from "react";
import LogoutButton from "../pages/Auth/LougoutButton";
import { sideBarOptions } from "./sidebarOptions";
import { useAuthenticatedUser } from "../components/Auth/AuthContext";

const { Header, Content } = Layout;

type LayoutProps = {
  action?: { label: string; goTo: string };
} & PropsWithChildren;

const LayoutComponent: React.FC<LayoutProps> = ({ action }) => {
  const location = useLocation();

  const breadcrumbItems = sideBarOptions
    .filter((option) => location.pathname.startsWith(option.key))
    .map((option) => (
      <Breadcrumb.Item key={option.key}>
        <Link to={option.key}>{option.label}</Link>
      </Breadcrumb.Item>
    ));

  const user = useAuthenticatedUser();

  useEffect(() => {
    if (user?.partner_id === "fcharge") {
      setFaviconAndTitle("/flexecharge.svg", "Flexecharge");
    }
  }, [user]);

  const setFaviconAndTitle = (faviconUrl: string, title: string) => {
    let link = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement | null;

    if (!link) {
      link = document.createElement("link") as HTMLLinkElement;
      document.head.appendChild(link);
    }

    link.type = "image/svg+xml";
    link.rel = "icon";
    link.href = faviconUrl;

    document.title = title;
  };

  return (
    <Layout className="h-full">
      {/* Sidebar */}
      <SideBar />
      {/* Main Content Area */}
      <Layout className="px-6">
        {/* Header */}
        <Header className="mb-4 bg-white px-5 mt-4 flex items-center justify-between">
          {/* Breadcrumb */}
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            {breadcrumbItems}
          </Breadcrumb>
          <div className="flex items-center gap-4">
            {action && (
              <LinkButton to={action.goTo} type="primary">
                {action.label}
              </LinkButton>
            )}
            <LogoutButton />
          </div>
        </Header>

        {/* Content */}
        <Content className="shadow-sm bg-white">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutComponent;
